import { type UseQueryResult } from '@tanstack/react-query';

import { useApiQuery } from '../../../lib/api/hooks.js';
import { queryKeys } from '../../../lib/api/query-keys.js';
import { paymentPolicyEndpoints } from './endpoints.js';
import { paymentPolicyDetail, type PaymentPolicyDetail } from './schemas.js';

/**
 * Reads for the Payment Policies module.
 *
 * The list is not here: `ResourceListPage` owns list fetching so that search,
 * sort, filtering, pagination and column selection are implemented once rather
 * than per resource. A module supplies its endpoint, its row schema and its
 * filters, and the list page does the rest.
 */

export function usePaymentPolicyDetail(policyId: string): UseQueryResult<PaymentPolicyDetail> {
  return useApiQuery({
    queryKey: queryKeys.paymentPolicies.detail(policyId),
    path: paymentPolicyEndpoints.detail(policyId),
    schema: paymentPolicyDetail,
  });
}
